import { render } from "./Dashboards.vue?vue&type=template&id=74e4cf18&ts=true"
import script from "./Dashboards.vue?vue&type=script&lang=ts"
export * from "./Dashboards.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__